import { Injectable } from '@angular/core';

@Injectable()
export class ValidationService {
    constructor() {}

    validatePassword(password:string):boolean {
        if((password != null) &&
           ((password.length < 8 ) || (password.length > 123))
          ){
               return false;
        }
        else {
            //Passwords must pass 3 out of the 4 complex requirements:
            var complexRequirementsCount = 0;
            if(/[A-Z]/.test(password)) complexRequirementsCount++;
            if(/[a-z]/.test(password)) complexRequirementsCount++;
            if(/[0-9]/.test(password)) complexRequirementsCount++;
            if(/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/.test(password)) complexRequirementsCount++;

            if(complexRequirementsCount >= 3){
                //password cannot contain control characters
                if((/[\t\n\v\f\r]/.test(password))){
                    return false;
                }
                else return true;
            }
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/validation.service.ts